import {
  Button,
  CircularProgress,
  makeStyles,
  withStyles,
  Grid,
  Typography
} from '@material-ui/core'
import { TFunction } from 'i18next'
import { useState, useEffect } from 'react'
import {
  Navigate,
  OpenDialog,
  CloseDialog,
  UpdateStatusWithForm
} from '../../../actions/types'
import customCloseIcon from '../../../images/customCloseIcon.svg'
import { MuiClasses } from '../../../types'
import { Application, ApplicationStatus } from '../../../types/applications'
import { Apartment } from '../../../types/apartments'
import Suggest from '../../Apartment/Stepper/Steps/Suggest'
import Dialog from '../../Dialog'
import ApplicationsApi from '../../../services/applications'
import apartmentsApi from '../../../services/apartments'
import { toast } from 'react-toastify'
import PaymentPopup from '../../PayForPublish/PaymentPopup'

const styles = () => ({
  primaryBtn: {
    backgroundColor: '#94004A',
    '&:hover': {
      backgroundColor: '#670033'
    }
  },
  actionButtons: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    paddingBottom: '16px',
    marginRight: '16px',
  },
  actionButton: {
    padding: '0.3rem 1.4rem',
    marginBottom: '16px',
    marginLeft: '16px',
    fontSize: '12px'
  },
  actionButtonDark: {
    backgroundColor: '#94004A',
    '&:hover': {
      backgroundColor: '#670033',
    },
  },
  outlinedActionButton: {
    border: '1px solid #C4C4C4',
    backgroundColor: '#94004A',
    color: '#FFFFFF',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.15)',
    '&:hover': {
      backgroundColor: '#670033',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)'
    }
  },
  /** White outlined button used for Not Interested action */
  outlinedWhiteActionButton: {
    color: '#000000',
    border: '1px solid #C4C4C4',
    padding: '0.3rem 1.4rem',
    fontSize: '12px',
    boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.12)',
    backgroundColor: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#f2f2f2',
      boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.12)'
    }
  },
  chatUsed: {
    color: '#fff',
    background: '#94004A',
    padding: '0.1rem 0.6rem',
    lineHeight: '20px',
    alignSelf: 'flex-end',
    marginTop: '0px',
    marginBottom: '16px',
    fontSize: '0.8rem',
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '-14px',
      width: 0,
      height: 0,
      borderTop: '20px solid #94004A',
      borderLeft: '15px solid transparent'
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: '-14px',
      width: 0,
      height: 0,
      borderBottom: '20px solid #94004A',
      borderLeft: '15px solid transparent'
    }
  }
})

const useStyles = makeStyles({
  previewPhone: {
    boxSizing: 'border-box',
    paddingBottom: '16px',
    color: '#A2A4AF',
    fontSize: '20px ',
    paddingLeft: '8px',
    '& div': {
      paddingTop: 0,
      paddingBottom: 0
    }
  }
})

interface ApplicationCardButtonsProps {
  t: TFunction
  classes: MuiClasses
  isSelected?: boolean
  application: Application
  selectApplication: (applicationId: string) => void
  chatWithApplicant: (applicationId: string) => void
  openDialog: OpenDialog
  closeDialog: CloseDialog
  // invitableAndRejectableStatus: boolean
  // onlyInviteAllowed: boolean
  disableActions: boolean
  invitable: boolean
  PhoneDisplay: any
  status: string
  updateStatusWithForm: UpdateStatusWithForm
  navigate: Navigate
  isAdmin?: boolean
  apartment: Apartment
  moveToContractPage?: () => void
  cancelInvitations?: () => void
}

const ConfirmModel = ({
  classes,
  t,
  dialogId,
  closeDialogAction,
  confirmDialogAction,
  loading
}: {
  classes: MuiClasses
  t: TFunction
  dialogId: string
  loading: boolean
  closeDialogAction: CloseDialog
  confirmDialogAction: () => void
}) => {
  return (
    <Grid
      container
      justify='center'
      style={{ maxWidth: '800px', margin: 'auto' }}
    >
      <Typography variant='h5' align='center' className={classes.modalTitle}>
        {t('confirmTenant.label')}
      </Typography>
      <Grid item sm={12} style={{ margin: '15px 0 20px 0' }}>
        <Suggest
          isModal
          containerMaxWidth='100%'
          contentMaxWidth='100%'
          content={t('confirmTenant.confirmMessage')}
        />
      </Grid>

      <Grid container spacing={2}>
        <Grid item sm={12} xs={12}>
          <Button
            variant='contained'
            fullWidth
            className={classes.primaryBtn}
            onClick={() => {
              confirmDialogAction()
              // closeDialogAction(dialogId)
            }}
          >
            {loading ? (
              <>
                <CircularProgress
                  size={21}
                  style={{ color: '#E2EBFD', marginLeft: '5px' }}
                />
              </>
            ) : (
              <>{t('confirmTenant.confirmButtonText')}</>
            )}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}

const ApplicationCardButtons = ({
  t,
  classes,
  isSelected,
  application: { applicationId, apartmentId, applicants },
  application,
  openDialog,
  closeDialog,
  selectApplication,
  chatWithApplicant,
  invitable,
  disableActions,
  PhoneDisplay,
  status,
  updateStatusWithForm,
  navigate,
  isAdmin,
  moveToContractPage,
  cancelInvitations,
  apartment
}: // invitableAndRejectableStatus,
  // onlyInviteAllowed,
  //disableAction
  ApplicationCardButtonsProps) => {
  const myClasses = useStyles()
  const [isLoading, setIsLoading] = useState(false)
  const [requestingInfo, setRequestingInfo] = useState(false)
  const [chatUsed, setChatUsed] = useState(false)

  useEffect(() => {
    if (!isAdmin) return
    console.log("running checkChatUsage.")
    const checkChatUsage = async () => {
      try {
        const response = await ApplicationsApi.checkIfLandlordUsedChat(
          apartmentId,
          applicationId,
          apartment.userId
        )
        setChatUsed(response.landlordUsedChat)
      } catch (error) {
        console.error('Error checking if chat is used', error)
      }
    }

    checkChatUsage()
  }, [applicationId, apartmentId, apartment])

  const sendContractInfoRequest = async (application: Application, apartment: Apartment) => {
    setRequestingInfo(true)
    try {
      await apartmentsApi.sendContractInfoRequest(application, apartment)
      const message = t('applicantCard.contractInfoRequestSent')
      toast.info(message, { autoClose: 25000 })
      closeDialog(`getMoreInfoDialog-${applicationId}`)
    } catch (error) {
      //console.error(error)
      const message = t('applicantCard.contractInfoRequestFailed')
      toast.info(message, { autoClose: 25000 })
    } finally {
      setRequestingInfo(false)
    }
  }

  const MoveToContractPageButton = () => (
    <Button
      variant='outlined'
      color='primary'
      onClick={() => moveToContractPage()}
      className={`${classes.actionButton} ${classes.outlinedActionButton}`}
    >
      {t('applicantCard.generateContract')}
    </Button>
  )

  const RejectApplicationButton = () => (
    <span>
      <Button
        variant='outlined'
        disabled={isSelected}
        className={`${classes.actionButton} ${classes.outlinedWhiteActionButton}`}
        onClick={() => openDialog(`rejectDialog-${applicationId}`)}
      >
        {t('general.reject')}
      </Button>
    </span>
  )

  const GenerateContractPopupOpenerButton = () => (
    <span>
      <Dialog
        dialogId='PaymentPopup'
        //disabled={isApartmentCancelledDisabled(status)}
        variant='outlined'
        fullScreenDialogMobile={true}
        //title={t('apartments.cancel.label')}
        buttonLabel={
          isLoading ? (
            <CircularProgress
              size={23}
              style={{ color: '#ff0000' }}
            />
          ) : (
            t('paymentPopup.productNames.generateContract')
          )
        }
        buttonClassName={`${classes.actionButton} ${classes.outlinedActionButton}`}
        Content={
          <PaymentPopup
            productTags={["generateContract"]}
            headertext={t('paymentPopup.headerTexts.generateContract')}
            infotext={
              <span
                dangerouslySetInnerHTML={{
                  __html: `${t('paymentPopup.suggestTexts.generateContract')} <a href="https://vuokraovi.leea.fi/generateContract" target="_blank">${t('paymentPopup.contract.downloadText')}</a>`
                }}
              />
            }
            apartment={apartment}
            application={application}
          />
        }
      />
    </span>
  )

  const SelectApplicantButton = () => (
    <span>
      <Button
        variant="contained"
        onClick={() => selectApplication(applicationId)}
        className={`${classes.actionButton} ${classes.actionButtonDark}`}
        style={
          isSelected
            ? {
              background: '#FFFFFF',
              color: '#670033',
              border: '1px solid #670033',
            }
            : undefined
        }
      >
        {isSelected
          ? t('general.selected')
          : status === ApplicationStatus.accepted
            ? t('general.selectInvited')
            : t('general.select')}
      </Button>
    </span>
  )

  const ChatButton = () => (
    <span>
      <Button
        variant='contained'
        color='primary'
        onClick={() => chatWithApplicant(applicationId)}
        className={classes.actionButton}
      >
        {t('general.chat')}
      </Button>
    </span>
  )

  const SendContractRequestButton = () => (
    <span>
      <Button
        variant='outlined'
        disabled={requestingInfo}
        onClick={() => sendContractInfoRequest(application, apartment)}
        className={`${classes.actionButton} ${classes.outlinedActionButton}`}
      >
        {
          requestingInfo ? (
            <CircularProgress size={16} style={{ marginRight: '8px', color: '#FFFFFF' }} />
          ) : null
        }
        <span style={{ color: '#FFFFFF' }}>{t('applicantCard.requestContractInfo')}</span>
      </Button>
    </span>
  )

  const ConfirmTenantButton = () => (
    <Dialog
      buttonVariant='outlined'
      dialogId={`confirm-tenant-${applicationId}`}
      noOpenDialogButton
      Content={
        <ConfirmModel
          classes={classes}
          t={t}
          dialogId={`confirm-tenant-${applicationId}`}
          loading={isLoading}
          confirmDialogAction={() => {
            setIsLoading(true)
            updateStatusWithForm({
              contractWantedId: applicationId,
              status: 'rentContractWanted',
              isFromApplicationCard: true
            })
          }}
          closeDialogAction={() =>
            closeDialog(`confirm-tenant-${applicationId}`)
          }
        />
      }
      customCloseIcon={customCloseIcon}
      borderRadius='10px'
      maxWidth='md'
    />
  )

  const CancelInvitationsButton = () => (
    <span>
      <Button
        variant='outlined'
        color='inherit'
        onClick={() => openDialog(`cancelInvitationsDialog-${applicationId}`)}
        className={`${classes.actionButton} ${classes.outlinedWhiteActionButton}`}
      >
        {t('applicantCard.cancelInvitationsShort')}
      </Button>
    </span>
  )

  const buttonGroups = () => {

    switch (status) {
      case ApplicationStatus.created:
      case ApplicationStatus.accepted:
      case ApplicationStatus.showingReserved:
        return (
          <>
            <SelectApplicantButton />
            <ChatButton />
            {applicants?.[0]?.idNumber ? <MoveToContractPageButton /> : <SendContractRequestButton />}
          </>
        )
      case ApplicationStatus.invitationsSent:
        return (
          <>
            <CancelInvitationsButton />
            <ChatButton />
          </>
        )
      case ApplicationStatus.noAvailableTimes:
        return (
          <>
            <SelectApplicantButton />
            <ChatButton />
            {applicants?.[0]?.idNumber ? <MoveToContractPageButton /> : <SendContractRequestButton />}
          </>
        )
      case ApplicationStatus.wantsContract:
        return (
          <>
            <SelectApplicantButton />
            <ChatButton />
            {applicants?.[0]?.idNumber ? <MoveToContractPageButton /> : <SendContractRequestButton />}
          </>
        )
      default:
        return (
          <>
            {!isAdmin && window.talkSession && <ChatButton />}
          </>
        )
    }
  }

  return (
    <>
      <section className={classes.actionButtons}>
        {buttonGroups()}
      </section>

      {/*** https://dwellet.atlassian.net/browse/FIKSU-1086 */}
      <div className={myClasses.previewPhone}>{PhoneDisplay}</div>
      {isAdmin && chatUsed && (
        <span className={classes.chatUsed}>
          {' '}
          {t('application.chat.landlordUsed')}
        </span>
      )}

      <ConfirmTenantButton />
    </>
  )
}

export default withStyles(styles)(ApplicationCardButtons)
